import React from "react";

const History = ({ history, moveToHist, moveIndex }) => {
	return (
		<div className="history-wrapper">
			<ul className="history">
				{history.map((_, move) => {
					return (
						<li key={move}>
							<button
								className={`btn-move ${ move === moveIndex ? 'active' : '' }`}
								style={{
									fontWeight: move === moveIndex ? "bold" : "normal",
								}}
								type="button"
								onClick={() => {
									moveToHist(move);
								}}
							>
								{move === 0 ? `Start the Game` : `Go to move #${move}`}
							</button>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default History;
